import styled from "@emotion/styled";
import * as RadioGroup from "@radix-ui/react-radio-group";
import React from "react";
import { baseBoxCss } from "./CheckboxCard";
import { doNothing } from "../../../utils/doNothing";

interface Props {
  children: React.ReactNode;
  direction?: "row" | "column";
  onValueChange?: (value: string) => void;
}

const RadioBoxGroup = (props: Props) => (
  <RadioBoxGroup.Root
    onValueChange={props.onValueChange ?? doNothing}
    direction={props.direction ?? "row"}
  >
    {props.children}
  </RadioBoxGroup.Root>
);

RadioBoxGroup.Item = styled(RadioGroup.Item)`
  ${baseBoxCss};

  padding: 8px 16px;
`;

RadioBoxGroup.Root = styled(RadioGroup.Root)<{ direction: "row" | "column" }>`
  display: flex;
  gap: 8px;
  flex-direction: ${(props) => props.direction};
  ${RadioBoxGroup.Item} {
    width: 100%;
  }
`;

export default RadioBoxGroup;
